import React from 'react';
import useProps from '../_util/useProps';
import { useEffect } from 'react';
import { CesiumHeatmap } from './CesiumHeatmap';
import { transformGeometry } from '../feature-layer/createFeatureCollection';

export default function(props) {
    const {
        data = [],
        heatmapDataOptions,
        heatmapOptions,
        name,
        id: key,
        _key,
        groupLayer,
        layerControl = true,
        show = true,
        initRadius,
        ...otherProps
    } = props;
    const { map } = useProps();
    useEffect(() => {
        const layer = new CesiumHeatmap(map, {
            points: data.map(v => {
                let { geometryInfo } = v;
                let [x, y] = transformGeometry(geometryInfo).coordinates;
                return {
                    ...v,
                    x,
                    y,
                };
            }),
            heatmapDataOptions: {
                max: Math.max(...data.map(v => v.value)),
                min: Math.min(...data.map(v => v.value)),
                ...heatmapDataOptions,
            },
            heatmapOptions: {
                maxOpacity: 0.9,
                minOpacity: 0.1,
                ...heatmapOptions,
            },
            name,
            key: key || _key,
            layerControl,
            show,
            initRadius,
            ...otherProps
        });
        if (groupLayer) {
            groupLayer.addLayer(layer);
        } else {
            map.addLayer(layer);
        }
        return () => {
            layer.remove();
            if (groupLayer) {
                groupLayer.removeLayer(layer);
            } else {
                map.removeLayer(layer);
            }
        };
    }, []);
    return <></>;
}
